import { render } from "./Electro3Menu.vue?vue&type=template&id=6ffffdc3&scoped=true"
import script from "./Electro3Menu.vue?vue&type=script&lang=js"
export * from "./Electro3Menu.vue?vue&type=script&lang=js"

import "./Electro3Menu.vue?vue&type=style&index=0&id=6ffffdc3&scoped=true&lang=css"
import "./Electro3Menu.vue?vue&type=style&index=1&id=6ffffdc3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffffdc3"]])

export default __exports__